import { GameTable } from '../../../../store/state/GameTable';

export interface WaitingHostButtonProps {
  table: GameTable;
}

export enum WaitingHostSource {
  REBUY = 'REBUY',
  BUYIN = 'BUYIN',
}
